import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize: 52,
  fontWeight: 500,
  lineHeight: '40px',
  marginBottom: 16,
  color: theme.palette.textPrimary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: 32,
    lineHeight: '32px'
  }
}));

export default PageTitle;
